











































































































































































import { Vue, Component, Prop } from "vue-property-decorator";
import { validate, format } from "rut.js";

@Component
export default class Login extends Vue {
  store = this.$store.direct;

  valid = false;
  valid2 = false;

  step = 1;

  form = {
    email: "",
    password: ""
  };

  validation = {
    id: "",
    token: "",
    full_name: "",
    rut: "",
    password: "",
    password_confirmation: ""
  };

  get rut() {
    return this.validation.rut;
  }

  set rut(val: string) {
    this.validation.rut = format(val);
  }

  rules = {
    required: (v: string) => (v && v.length > 0) || "Campo requerido",
    min: (v: string) => v.length > 6 || "Mínimo 6 carácteres",
    confirmation: (p: string) =>
      p == this.validation.password || "Las contraseñas no coinciden",
    rut: (r: string) => validate(r) || "Rut no válido"
  };

  async login() {
    let result = await this.store.dispatch.session.login(this.form);
    if (result.error) {
      this.store.commit.PUSH_MESSAGE({
        message: "Los datos ingresados no son correctos",
        type: "error"
      });
    } else {
      if (result.data && result.data.user.data.attributes.validated) {
        this.store.commit.PUSH_MESSAGE({
          message: "Has iniciado sesión",
          type: "success"
        });
        this.$router.push({ path: this.$route.redirectedFrom || "/" });
      } else {
        this.validation.id = result.data ? result.data.user.data.id : "";
        this.validation.token = result.data ? result.data.token : "";
        this.step = 2;
      }
    }
  }

  loginSSO() {
    this.store.state.session.client.signinRedirect();  
  }

  async validate() {
    let { id, token, rut, full_name, password } = this.validation;
    let result = await this.store.dispatch.session.validate({
      id: id,
      token: token,
      payload: {
        user: {
          rut: rut,
          full_name: full_name,
          password: password,
          validated: true
        }
      }
    });
    if (result.error) {
      this.store.commit.PUSH_MESSAGE({
        message: "Ha ocurrido un error. Intente nuevamente.",
        type: "error"
      });
      this.validation = {
        id: "",
        token: "",
        full_name: "",
        rut: "",
        password: "",
        password_confirmation: ""
      };
      this.form = {
        email: "",
        password: ""
      };
      this.step = 1;
    } else {
      this.store.commit.PUSH_MESSAGE({
        message: "Has iniciado sesión",
        type: "success"
      });
      this.$router.push({ path: this.$route.redirectedFrom || "/" });
    }
  }
}
